import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import FixtureModel from "../../FixtureManagement/models/FixtureModel";
import SupportSheetModel from "../models/SupportSheetModel";

export interface GetSupportSheetByIdParam {
    id: string,
}

export interface DeleteParam {
    id: string,
}

export interface GetSupportSheetAndFixtureByIdResponse {
    fixture: FixtureModel,
    supportSheet: SupportSheetModel
}

export interface SendEmailParam {
    emailTo: string,
    emailCc: string,
    subject: string,
    content: string,
    files: File[]
}

const SupportSheetApi = {
    GetById(param: GetSupportSheetByIdParam) {
        return Api.get<GetSupportSheetByIdParam, BaseResponse<GetSupportSheetAndFixtureByIdResponse>>("/api/SupportSheet/GetById", param);
    },
    Delete(param: DeleteParam) {
        return Api.post<DeleteParam, BaseResponse<SupportSheetModel[]>>("/api/SupportSheet/Delete", param);
    },
    Save(param: SupportSheetModel) {
        return Api.post<SupportSheetModel, BaseResponse<string>>("/api/SupportSheet/Save", param);
    },
};
export default SupportSheetApi;